export const getApiUrl = (endpoint = '') => {
  const base = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? 'http://localhost:5000/api'
    : 'https://alquranlesson.expertdesignhub.com/api';
  return `${base}${endpoint}`;
};
